<template>
  <tr
    class="domain-list-item"
    :class="{ 'domain-list-item_active': item.valid }"
  >
    <td class="domain-list-item-icon">
      <i :class="`mdi mdi-${icon}`"></i>
      <p>{{ text }}</p>
    </td>

    <td>
      {{ item.domain }}
    </td>

    <td>
      <domain-list-item-actions
        :item="item"
        @selected="emitSelected"
        @deleted="emitDeleted"
      />
    </td>
  </tr>
</template>

<script>
import DomainListItemActions from "@components/modules/domain/list/item/actions/DomainListItemActions";

export default {
  components: {
    DomainListItemActions,
  },

  data() {
    return {
      active: false,
    };
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  created() {},

  computed: {
    icon() {
      return this.item.valid ? `check-circle` : `minus-circle`;
    },
    text() {
      return this.item.valid
        ? this.$t("message.email.message.validated")
        : this.$t("message.email.message.pending");
    },
  },

  methods: {
    emitSelected() {
      this.$emit("selected", this.item);
    },
    emitDeleted() {
      this.$emit("deleted");
    },
  },
};
</script>

<style lang="scss" scoped>
.domain-list-item {
  td {
    font-size: 15px;
  }

  .domain-list-item-icon {
    display: flex;
    align-items: center;

    i {
      display: flex;
      align-items: center;
      margin-right: 5px;
    }

    p {
      margin: 0;
    }
  }

  &.domain-list-item_active {
    .domain-list-item-icon {
      color: green;
    }
  }
}
</style>
